var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFindProducts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-91"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.82,
    y: 342.17,
    width: 274.46,
    height: 40.63,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.93,
    y: 181.48,
    width: 5.18,
    height: 133.83,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.66,
    y: 181.48,
    width: 5.18,
    height: 133.83,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.04 382.49 115.04 342.49 91.03 315.31 51.17 314.51 51.17 382.66 115.04 382.49",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.2 382.49 385.2 342.49 409.2 315.31 449.07 314.51 449.07 382.66 385.2 382.49",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.42,350.67c-.71-.42-1-1.12-.6-1.7.79-1.06,3-.33,3.92.61s1.76,2.13,3.35,2.11L403.82,346c-.42-.57.5-1.19,1.28-.85a15.39,15.39,0,0,1,4.88,3.15l-8.38-9.48a3.33,3.33,0,0,1-1-1.74,1.45,1.45,0,0,1,1.43-1.42,2.93,2.93,0,0,1,2.4,1.25l5.41,6.23a30.28,30.28,0,0,1-5.86-18c0-1.43,2.83-1.86,3.72-.57a32.05,32.05,0,0,1,4.7,10.15,7.26,7.26,0,0,1,1.68-8.35,2.51,2.51,0,0,1,1.78-.73c1.92,0,2.1,1.68,1.81,2.86q-1.71,7.07-3.43,14.11a11.42,11.42,0,0,1,2.63-4.6c.85-.93,2.95-.35,2.59.73a38.25,38.25,0,0,1-4.81,9.55c.51-1.44,1.11-3,3.11-3.74,1.34-.51,3.12-.29,3.84.65,1.08,1.41-1.24,2.88-2.95,4-4.14,2.68-4.66,6.19-4.37,9.85C409.73,357.77,404.84,352.72,401.42,350.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.84,352a1.27,1.27,0,0,0,.62-1.65c-.58-1.12-2.52-.52-3.35.39s-1.64,2.07-3,2l4-5.66c.41-.57-.37-1.31-1.09-1a13.23,13.23,0,0,0-4.59,3l8.13-9.66a3.81,3.81,0,0,0,1.05-1.87,1.81,1.81,0,0,0-1.17-1.92c-1-.29-1.74.45-2.3,1.12l-5.43,6.59a42.58,42.58,0,0,0,6.71-21.89c.09-2.06-2.81-3.64-3.83-2a42,42,0,0,0-5.34,13.09c1.44-3.45.82-8.11-1.87-12.46a4,4,0,0,0-2.15-1.76c-2.38-.7-2.53,1.94-2.12,3.89,1.52,7.3,2.91,13.95,4.18,20a18.16,18.16,0,0,0-2.91-6.21c-1-1.41-3.41-1-2.93.49a57.13,57.13,0,0,0,5.46,12.26c-.53-1.66-1.17-3.5-3.31-4.63-1.49-.78-3.47-.73-4.24.35-1.14,1.61,1.56,3.58,3.45,5,4.27,3.19,4.79,6.83,4.53,10.43C419.45,358.59,423.86,353.82,426.84,352Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.32,382.48l-2.21-20s8.1-7,16.87-4.66,7.62,4.1,7.62,4.1l-1.46,20.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.57 351.06 99.74 340.19 79.22 340.19 85.83 351.06 107.57 351.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.04 349.37 98.43 340.19 81.09 340.19 86.67 349.37 105.04 349.37",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.22 340.19 85.83 351.06 107.57 351.06 107.57 354.86 71.35 355.1 71.35 351.06 74.15 351.06 79.22 340.19",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.42 351.06 89.46 351.06 89.46 354.98 109.42 354.9 109.42 351.06",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.96 355.13 104.44 382.59 76.69 382.69 74.16 355.13 106.96 355.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.55 354.9 86.33 382.65 76.69 382.69 74.16 355.13 85.55 354.9",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.35,
    y: 181.24,
    width: 387.55,
    height: 133.83,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.19,194.53c-2.11-.68-4.87-.06-6,1.37L347.6,288.06c-1.61,2-6.1,2.23-7.63.35l-57.65-71c-1.06-1.3-3.76-1.69-5.9-.84l-78.09,30.9a6.5,6.5,0,0,1-4.43.12L83.05,207.57c-2.06-.75-4.86-.18-6.08,1.22l-.26.29c-1.1,1.27-.52,2.76,1.34,3.43l115.33,41.68a6.5,6.5,0,0,0,4.43-.12l74.95-29.66c2.14-.84,4.84-.46,5.9.85l61,75.06c1.53,1.88,6,1.68,7.63-.35l81.48-102.06C429.79,196.63,429.1,195.15,427.19,194.53Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.04 342.53 385.8 342.49 409.62 315.31 90.52 314.86 115.04 342.53",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.94,
    y: 349.18,
    width: 51.04,
    height: 33.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.04,
    y: 349.18,
    width: 45.98,
    height: 33.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.08,
    y: 349.18,
    width: 45.98,
    height: 33.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.12,
    y: 349.18,
    width: 45.98,
    height: 33.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.16,
    y: 349.18,
    width: 51.04,
    height: 33.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.12,381.38a1.69,1.69,0,0,0,1.67,1.63,1.56,1.56,0,0,0,1.56-1.63,1.68,1.68,0,0,0-1.66-1.63,1.57,1.57,0,0,0-1.57,1.63Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.9,381.33a1.59,1.59,0,0,1-1.6,1.63,1.69,1.69,0,0,1-1.67-1.64,1.58,1.58,0,0,1,1.6-1.63,1.68,1.68,0,0,1,1.67,1.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.46,381.28a2,2,0,0,1-2,2.07,2.14,2.14,0,0,1-2.12-2.07,2,2,0,0,1,2-2.07,2.13,2.13,0,0,1,2.1,2.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.43,378.82l-.08-3.15H359a15.58,15.58,0,0,1,2.72.27l8.66,1.71a.81.81,0,0,1,.65.92.76.76,0,0,1-.77.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.43,378.82l-.08-3.15-4.65,0a14.64,14.64,0,0,0-2.72.25l-9.72,1.53a.78.78,0,0,0-.61.93.83.83,0,0,0,.82.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.82 361.38 351.11 361.34 351.47 375.66 357.22 375.68 356.82 361.38",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.82 354.76 351.75 354.74 353.85 363.27 356 361.37 355.82 354.76",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.87 356.7 351.83 357.69 351.75 354.74 355.82 354.76 355.87 356.7",
    style: {
      fill: "#e0e0e0",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.47 340.08 366.43 340.06 366.7 348.74 368.75 348.76 368.47 340.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.58,354.61h-.53v0A2.37,2.37,0,0,0,334.58,354.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.39,352.29a2.5,2.5,0,0,1-2.54,2.61l-18.28-.13-3.28,0-.2-7.35-.8-30.25a5.05,5.05,0,0,0-1.79-3.68l-2.75-2.36a5.28,5.28,0,0,0-3.22-1.24l3.16.05a5.17,5.17,0,0,1,3.29,1.25l2.76,2.34a5.13,5.13,0,0,1,1.79,3.69l.84,30.22,14.59.12a6.88,6.88,0,0,1,1.29.12,7.24,7.24,0,0,1,4.72,3.28A2.59,2.59,0,0,1,377.39,352.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.22,356.67l-1-37.59a5.06,5.06,0,0,0-1.79-3.69l-2.75-2.34a5.22,5.22,0,0,0-3.3-1.25l-7.59-.12a4.86,4.86,0,0,0-3.6,1.47l-1.91,2a4.65,4.65,0,0,0-1.3,3.32l.62,34.21a4,4,0,0,0,3.93,3.86Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.58,342.65a21.17,21.17,0,0,1,13.9.13,1.91,1.91,0,0,0,2.41-.91h0a1.91,1.91,0,0,0-1.36-2.41,24.78,24.78,0,0,0-16.22-.16,1.78,1.78,0,0,0-1.21,2.39h0A2.07,2.07,0,0,0,360.58,342.65Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.36,381.38a1.68,1.68,0,0,1-1.67,1.63,1.56,1.56,0,0,1-1.56-1.63,1.69,1.69,0,0,1,1.67-1.63,1.56,1.56,0,0,1,1.56,1.63Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.59,381.33a1.58,1.58,0,0,0,1.59,1.63,1.68,1.68,0,0,0,1.67-1.64,1.57,1.57,0,0,0-1.6-1.63,1.67,1.67,0,0,0-1.66,1.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,381.28a2,2,0,0,0,2,2.07,2.14,2.14,0,0,0,2.11-2.07,2,2,0,0,0-2-2.07,2.14,2.14,0,0,0-2.11,2.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.05,378.82l.09-3.15H142.5a15.37,15.37,0,0,0-2.71.27l-8.66,1.71a.81.81,0,0,0-.65.92.75.75,0,0,0,.77.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.05,378.82l.09-3.15,4.65,0a14.46,14.46,0,0,1,2.71.25l9.73,1.53a.78.78,0,0,1,.61.93.83.83,0,0,1-.82.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.66 361.38 150.38 361.34 150.01 375.66 144.26 375.68 144.66 361.38",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.67 354.76 149.73 354.74 149.56 361.34 145.49 361.37 145.67 354.76",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.61 356.7 149.66 357.69 149.73 354.74 145.67 354.76 145.61 356.7",
    style: {
      fill: "#e0e0e0",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.01 340.08 135.06 340.06 134.78 348.74 132.73 348.76 133.01 340.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,354.61h.53v0A2.24,2.24,0,0,1,166.91,354.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.09,352.29a2.52,2.52,0,0,0,2.55,2.61l18.28-.13,3.27,0,.2-7.35.81-30.25a5,5,0,0,1,1.79-3.68l2.75-2.36a5.28,5.28,0,0,1,3.22-1.24l-3.17.05a5.21,5.21,0,0,0-3.29,1.25l-2.75,2.34A5.06,5.06,0,0,0,146,317.2l-.84,30.22-14.59.12a6.88,6.88,0,0,0-1.29.12,7.2,7.2,0,0,0-4.72,3.28A2.6,2.6,0,0,0,124.09,352.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.2,354.75l1-37.6a5,5,0,0,1,1.79-3.68l2.74-2.35a5.24,5.24,0,0,1,3.3-1.25l7.6-.12a4.83,4.83,0,0,1,3.59,1.48l1.92,2a4.69,4.69,0,0,1,1.29,3.32l-.61,34.22a4,4,0,0,1-3.94,3.85Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.91,342.65a21.2,21.2,0,0,0-13.91.13,1.9,1.9,0,0,1-2.4-.91h0a1.91,1.91,0,0,1,1.35-2.41,24.78,24.78,0,0,1,16.22-.16,1.76,1.76,0,0,1,1.21,2.39h0A2.06,2.06,0,0,1,140.91,342.65Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-91"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-91",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--News--inject-91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--monitor-screen--inject-91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--PC--inject-91"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.89 183.31 319.04 182.71 325.8 110.32 430.64 110.93 423.89 183.31",
    style: {
      fill: "#407BFF"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "325.8 110.32 319.04 182.71 423.89 183.31 430.64 110.93 325.8 110.32",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M350,148.93a19.68,19.68,0,0,0-2.56-.88,13.62,13.62,0,0,0-1.54-.33,2.28,2.28,0,0,1-.59-1.86,7.82,7.82,0,0,1,.51-1.37l-.1-.07a7,7,0,0,0,4.7-4.42,25.3,25.3,0,0,0,1.1-5.22c0-.26-.24-1.16-.2-1.42s.31-.87.34-1.09a7.26,7.26,0,0,0-.52-4.08c-.92-1.49-2.33-2.18-5.42-2.31-3.86-.18-6.91,1-7.35,3.27-2.19,11.2,1.15,12.84,2,13.79a7.63,7.63,0,0,1-1.76,4.87,13.3,13.3,0,0,0-3.93,1.36c-.86.46-4.34,2.24-4.86,3.06-1.85,3-3.32,9.82-3.32,9.82l29.49.15v-7.12a8.61,8.61,0,0,0-.65-1.64A10.36,10.36,0,0,0,350,148.93Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "340.1 179.64 324.22 179.64 325.52 164.75 341.29 164.75 340.1 179.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.24 164.75 384.86 164.75 383.56 179.64 341.29 179.64 342.24 164.75",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.25 161.68 363.57 161.68 367.03 122.16 424.71 122.16 421.25 161.68",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M418.32,153.52a1.49,1.49,0,0,1-.54-.11,3.1,3.1,0,0,1-1.54-3.12,13.11,13.11,0,0,1,.17-1.42,8.32,8.32,0,0,0,.16-2c-.08-1.05-.79-2.19-1.8-2.21a2.11,2.11,0,0,0-1.86,1.63,7.31,7.31,0,0,0-.28,1.89c0,.33,0,.65-.08,1a3.57,3.57,0,0,1-1.41,2.67,2,2,0,0,1-1.82.08,1.46,1.46,0,0,1-.75-.76l-1.49.89a.2.2,0,0,1-.17,0,.19.19,0,0,1-.14-.11,16,16,0,0,1-.74-1.76,1,1,0,0,0-1-.68h0a1,1,0,0,0-1,.72l-.87,2.68a.21.21,0,0,1-.2.15h0a.23.23,0,0,1-.21-.15l-.42-1.2a1.53,1.53,0,0,1-.26.31,1.42,1.42,0,0,1-1,.37,1.4,1.4,0,0,1-1-.5,1.46,1.46,0,0,1-.22-.35,1.73,1.73,0,0,1-.29.23,1.26,1.26,0,0,1-1,.14,1.28,1.28,0,0,1-.75-.73.35.35,0,0,0-.6-.35,1.75,1.75,0,0,1-1.38-.75,2.77,2.77,0,0,1-.38-1.2,2.36,2.36,0,0,1-.42.33,2.7,2.7,0,0,1-2.72,0c-1.28-.82-1.79-2.39-2.2-3.92l-2.54-9.57a7.67,7.67,0,0,0-1.05-2.62,2.5,2.5,0,0,0-2.29-1.1,4.08,4.08,0,0,0-.84.31,3.42,3.42,0,0,1-1.15.35A1.33,1.33,0,0,1,381,132l0-.1-2.34,2.21a.22.22,0,0,1-.29,0,.23.23,0,0,1,0-.29.23.23,0,0,0,0-.31.69.69,0,0,0-.71-.24,2.09,2.09,0,0,0-.88.78c-.1.12-.19.24-.29.35a1.41,1.41,0,0,1-1.83.44,1.62,1.62,0,0,1-.36-.44,1.53,1.53,0,0,0-.14-.21,1.55,1.55,0,0,0-2-.19,5,5,0,0,0-1.56,1.8.19.19,0,0,1-.17.1.23.23,0,0,1-.19-.09l-.94-1.33a.22.22,0,1,1,.35-.25l.76,1.06a4.79,4.79,0,0,1,1.53-1.67,1.83,1.83,0,0,1,2.72.55,1.24,1.24,0,0,0,.25.33c.37.28.95-.05,1.25-.39q.13-.15.27-.33a2.54,2.54,0,0,1,1.08-.92,1.12,1.12,0,0,1,1.19.39.82.82,0,0,1,.11.17l2.44-2.31a.21.21,0,0,1,.3,0,.22.22,0,0,1,0,.3.32.32,0,0,0-.06.39,1,1,0,0,0,.84.52,3,3,0,0,0,1-.32,4.37,4.37,0,0,1,.94-.33,2.87,2.87,0,0,1,2.72,1.27,8,8,0,0,1,1.12,2.76l2.54,9.57c.4,1.51.86,2.93,2,3.66a2.25,2.25,0,0,0,2.27,0,1.39,1.39,0,0,0,.64-.79l0-.44a.22.22,0,0,1,.21-.2h0a.23.23,0,0,1,.22.2,1.67,1.67,0,0,1,0,.5,2.85,2.85,0,0,0,.32,1.74,1.29,1.29,0,0,0,1,.55h0a.7.7,0,0,0,.61-.29.22.22,0,0,1,.29-.06.21.21,0,0,1,.08.29.84.84,0,0,0,0,.68.82.82,0,0,0,1.56-.18.22.22,0,0,1,.24-.18.21.21,0,0,1,.18.24,1,1,0,0,0,.24.71,1,1,0,0,0,.66.35,1,1,0,0,0,.7-.26,1,1,0,0,0,.33-.67.21.21,0,0,1,.18-.21.22.22,0,0,1,.24.14l.42,1.21.67-2.07a1.48,1.48,0,0,1,1.4-1h0a1.43,1.43,0,0,1,1.37,1c.19.51.4,1,.63,1.51l1.53-.92a.2.2,0,0,1,.2,0,.2.2,0,0,1,.12.17,1,1,0,0,0,.59.72,1.49,1.49,0,0,0,1.41-.05,3.16,3.16,0,0,0,1.21-2.36c0-.31.06-.62.08-.93a8.15,8.15,0,0,1,.3-2,2.56,2.56,0,0,1,2.29-1.93,2.64,2.64,0,0,1,2.21,2.62,8.31,8.31,0,0,1-.16,2.06,11.06,11.06,0,0,0-.17,1.38,2.69,2.69,0,0,0,1.27,2.7,1.36,1.36,0,0,0,1.48-.49.8.8,0,0,0,.11-1,.22.22,0,1,1,.35-.25,1.19,1.19,0,0,1-.12,1.49A1.9,1.9,0,0,1,418.32,153.52Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M395.17,169l-1.37,6.84h-1.59L390,172.11l-.75,3.75h-1.89l1.36-6.84h1.6l2.26,3.74.74-3.74Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M398.15,170.52l-.23,1.15h3l-.28,1.44h-3.05l-.24,1.25H401l-.31,1.5h-5.48l1.37-6.84h5.35l-.31,1.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M413.73,169l-3.58,6.84h-2.07l-.5-4.12-2.18,4.12h-2.08l-.84-6.84h1.91l.52,4.37,2.31-4.37H409l.48,4.43,2.33-4.43Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M412.75,175.26l.77-1.44a4.26,4.26,0,0,0,2.27.67c.74,0,1.17-.23,1.17-.6,0-.92-3.32-.42-3.32-2.56,0-1.48,1.26-2.45,3.28-2.45a4.83,4.83,0,0,1,2.47.59l-.71,1.44a3.42,3.42,0,0,0-1.87-.52c-.8,0-1.23.29-1.23.66,0,.94,3.32.4,3.32,2.51,0,1.47-1.29,2.43-3.29,2.43A5.36,5.36,0,0,1,412.75,175.26Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.17,93.86,266,142.11a1.25,1.25,0,0,1-1.22,1.13l-44.62.08a1,1,0,0,1-1-1.12l5.38-62.76a1.25,1.25,0,0,1,1.22-1.13l30.06,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.17,93.86,266,142.11a1.25,1.25,0,0,1-1.22,1.13l-44.62.08a1,1,0,0,1-1-1.12l5.38-62.76a1.25,1.25,0,0,1,1.22-1.13l30.06,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.22,108.41l-31.5.15a1,1,0,0,0-1,.89l0,.29a.8.8,0,0,0,.82.88l31.5-.15a1,1,0,0,0,1-.89l0-.29A.8.8,0,0,0,261.22,108.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.52,116.84,229,117a1,1,0,0,0-1,.89l0,.29a.79.79,0,0,0,.81.88l31.5-.15a1,1,0,0,0,1-.89l0-.29A.8.8,0,0,0,260.52,116.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.82,125.26l-31.5.15a1,1,0,0,0-1,.89l0,.29a.8.8,0,0,0,.81.89l31.5-.16a1,1,0,0,0,1-.89l0-.29A.8.8,0,0,0,259.82,125.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.85,78.22l-1.24,14.56a1,1,0,0,0,1,1.12l14.51,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.85,78.22l-1.24,14.56a1,1,0,0,0,1,1.12l14.51,0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Info--inject-91"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.35,178.38H83.93a14.87,14.87,0,0,1-15.05-16.49l6.06-69.33a18.37,18.37,0,0,1,17.94-16.5H137.3a14.87,14.87,0,0,1,15,16.5l-6.07,69.33A18.35,18.35,0,0,1,128.35,178.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.35,178.38H83.93a14.87,14.87,0,0,1-15.05-16.49l6.06-69.33a18.37,18.37,0,0,1,17.94-16.5H137.3a14.87,14.87,0,0,1,15,16.5l-6.07,69.33A18.35,18.35,0,0,1,128.35,178.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.21,169H92.31a2.67,2.67,0,0,1-2.7-3h0a3.3,3.3,0,0,1,3.22-3h35.9a2.67,2.67,0,0,1,2.7,3h0A3.3,3.3,0,0,1,128.21,169Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.11,124.4H107.37a2.66,2.66,0,0,1-2.7-3h0a3.29,3.29,0,0,1,3.22-3h24.74a2.67,2.67,0,0,1,2.7,3h0A3.3,3.3,0,0,1,132.11,124.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.09,136h-33a2.66,2.66,0,0,1-2.7-3h0a3.29,3.29,0,0,1,3.21-3h33a2.67,2.67,0,0,1,2.7,3h0A3.29,3.29,0,0,1,131.09,136Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.07,147.68H105.33a2.67,2.67,0,0,1-2.7-3h0a3.29,3.29,0,0,1,3.22-3h24.74a2.67,2.67,0,0,1,2.7,3h0A3.29,3.29,0,0,1,130.07,147.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.05,159.32H104.31a2.67,2.67,0,0,1-2.7-3h0a3.3,3.3,0,0,1,3.22-3h24.74a2.66,2.66,0,0,1,2.7,3h0A3.29,3.29,0,0,1,129.05,159.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.8 112.88 87.72 112.88 90.14 85.26 137.22 85.26 134.8 112.88",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-91"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.77,
    y: 158.82,
    width: 12.67,
    height: 3.57,
    transform: "translate(-31.35 85.64) rotate(-15.16)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.77,
    y: 158.82,
    width: 12.67,
    height: 3.57,
    transform: "translate(-31.35 85.64) rotate(-15.16)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.03 159.86 299.09 159.6 300.56 165.05 302.94 163.31 302.03 159.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.26,
    y: 155.08,
    width: 18.97,
    height: 5.68,
    transform: "translate(-30.28 88.33) rotate(-15.16)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.26,
    y: 155.08,
    width: 18.97,
    height: 5.68,
    transform: "translate(-30.28 88.33) rotate(-15.16)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.52,160.12l-20.75,1L316.83,154l18.43-9.58,1.29,2.92a34,34,0,0,1,2.56,9.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,207.81c0-6.62,3.31-10,5.9-14.24l9.36-15.23c.45-.73-2.41,3.92-.82,1.14.89-1.55,3.92-1.57,5.14,1-3.27,6-3.86,11-5.8,17.56a92.79,92.79,0,0,1-3.4,9C279.36,218.21,275,210.69,275,207.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,180.5c.84-1.72,2.72-5.22,3.55-6.95a1.91,1.91,0,0,1,.55-.76,2,2,0,0,1,.69-.23,12.34,12.34,0,0,1,5.63-.18.58.58,0,0,1,.36.19.62.62,0,0,1,.11.34c.14,1,.28,2.08.43,3.12a1.42,1.42,0,0,1,0,.68,1.52,1.52,0,0,1-.44.54l-2.67,2.35a3.45,3.45,0,0,1-1.52.93,4.58,4.58,0,0,1-2.64-.71C292,179.41,289,180.5,289,180.5Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M289,180.5c.84-1.72,2.72-5.22,3.55-6.95a1.91,1.91,0,0,1,.55-.76,2,2,0,0,1,.69-.23,12.34,12.34,0,0,1,5.63-.18.58.58,0,0,1,.36.19.62.62,0,0,1,.11.34c.14,1,.28,2.08.43,3.12a1.42,1.42,0,0,1,0,.68,1.52,1.52,0,0,1-.44.54l-2.67,2.35a3.45,3.45,0,0,1-1.52.93,4.58,4.58,0,0,1-2.64-.71C292,179.41,289,180.5,289,180.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.54,161.81c.34-.06.7.3.8.81s-.09,1-.43,1-.69-.3-.79-.81S297.21,161.87,297.54,161.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.46,168.61a3,3,0,0,0,2.37-.93,18.82,18.82,0,0,1-3.3-3.93Z",
    style: {
      fill: "#b74d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.9,160.3a2.43,2.43,0,0,1,2.07-.84h.1a.31.31,0,1,0,0-.62,3,3,0,0,0-2.62,1,.3.3,0,0,0-.08.2.31.31,0,0,0,.3.32A.29.29,0,0,0,294.9,160.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.85,191.5c-8.83-.09-10.08-4.92-10.08-4.92,2.68-2.51,2.91-7.22,2.43-11.43a9.82,9.82,0,0,0,2.58,2.56,8.05,8.05,0,0,0,6.44,1.29.23.23,0,0,0,.11,0,1.11,1.11,0,0,0-.05.25c-.6,3.36-.21,7,3.3,8.1C295.58,187.32,300.58,191.6,290.85,191.5Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.6,177.73a11.81,11.81,0,0,0-.27,1.24.23.23,0,0,1-.11,0,8.05,8.05,0,0,1-6.44-1.29,9.82,9.82,0,0,1-2.58-2.56c-.11-1.07-.28-2.12-.46-3.07l9.5,5.45Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.07,187.34s1.48-4.28,3.61-5.6,11.35.29,12.79.89,2.83,4,2.83,4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.07,187.34s1.48-4.28,3.61-5.6,11.35.29,12.79.89,2.83,4,2.83,4Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.2,186c-1.43-.27-3-.52-4.65-.68a125.65,125.65,0,0,0-14.78-.15l-3.25.24c-5.16.27-10.43,4.63-9.5,9.71,5.13,27.95,3.18,43.46,2.56,48l34.76.34c4.19-28.53,3.5-43,2.24-50A9.22,9.22,0,0,0,300.2,186Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.69,233.34l-1.31,10.07c2.69-20.62,3.76-29.22,2.95-43.6l-9-2.86C304.91,215.77,302.9,220.41,306.69,233.34Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.07,170.66a8.94,8.94,0,0,1-4.5,7.42h-.05a7.56,7.56,0,0,1-2.19.88.23.23,0,0,1-.11,0,8.05,8.05,0,0,1-6.44-1.29,9.82,9.82,0,0,1-2.58-2.56c-1.68-2.41-2.33-5.6-3.48-10.07A8.81,8.81,0,0,1,290,154.15C296.66,155.48,299.33,164.7,299.07,170.66Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.52,178.09a7.56,7.56,0,0,1-2.19.88s.32-3.92.32-3.92S294.06,178.09,294.52,178.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.2,166.7c-2.31,1.06-1.34,6.17-3.43,7.69a2.51,2.51,0,0,1-.86.44c-1,.23-5.32-5.68-5.68-7.12-.93-3.76-.92-6.15,1.92-7.75a27.79,27.79,0,0,1,6.3-2.41c1,0,2,1.69,2.22,3.34.08.75-1,1.72-.59,2.09a6.43,6.43,0,0,1,1.61,2.63A9,9,0,0,1,295.2,166.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.31,174.82l-4.13.82-3-.49s-7.2-6.27-7.5-10.28,1.34-9,5.74-10.63a65,65,0,0,1,9.94-2.65s2.84.75,3.13,2.27a3,3,0,0,1-.46,2.41l-7.46,2.6A3.71,3.71,0,0,0,284,162.4v0C284.1,164.3,290.31,174.82,290.31,174.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.72,162.45c1.85.59,2.76,3.34,2.8,5.08.05,1.92-1.25,3.11-2.9,1.79a7.32,7.32,0,0,1-2.48-4C289.72,163.46,290.88,161.87,292.72,162.45Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.39,408.22a.16.16,0,0,1-.13-.14.14.14,0,0,1,.07-.17c.13-.05,2.54-1.42,3.69-1.11a.82.82,0,0,1,.53.38.62.62,0,0,1,0,.71c-.28.41-1.1.52-2,.52A12.68,12.68,0,0,1,285.39,408.22Zm3.22-1.16a7.26,7.26,0,0,0-2.71.88c1.29.18,3,.17,3.36-.27.07-.07.11-.16,0-.36a.43.43,0,0,0-.32-.23.86.86,0,0,0-.32,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.32,408.18a.21.21,0,0,1-.07-.15,4.37,4.37,0,0,1,1.06-2.66,1.18,1.18,0,0,1,.92-.27c.45,0,.61.27.61.46.14.8-1.5,2.26-2.34,2.64h-.07A.22.22,0,0,1,285.32,408.18Zm1.8-2.77a.84.84,0,0,0-.58.24,3.86,3.86,0,0,0-.91,2.12c.86-.51,2-1.68,1.89-2.15,0,0,0-.18-.32-.18h-.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.44 392.13 285.32 392.14 284.74 408.03 277.82 408.02 278.44 392.13",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.36,407.77c4.71,2.89,6.15,3,11.59,4.21,1.19.27.43,3.14-2.41,3.14-4.71,0-5.2-.23-9.22-.24-3.44,0-7.38.15-10.12.19a1.07,1.07,0,0,1-.25,0,1,1,0,0,1-.74-1.2l1.33-6.14a.61.61,0,0,1,.59-.47h7.57A3.17,3.17,0,0,1,286.36,407.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.44 392.14 278.12 400.3 285.03 400.31 285.32 392.15 278.44 392.14",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.68,408.05a.19.19,0,0,1-.13.13.15.15,0,0,1-.17-.09c-.06-.12-1.38-2.54-1-3.68a.84.84,0,0,1,.38-.52.63.63,0,0,1,.72,0c.39.3.49,1.12.48,2A12.63,12.63,0,0,1,227.68,408.05Zm-1.08-3.23a7.32,7.32,0,0,0,.8,2.71c.21-1.28.24-3-.2-3.34-.06-.08-.16-.11-.36,0a.44.44,0,0,0-.24.32,1.07,1.07,0,0,0,0,.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.67,408.11a.17.17,0,0,1-.15.07c-.07,0-1.94-.17-2.64-1.1a1.17,1.17,0,0,1-.26-.92c0-.44.29-.6.47-.6.79-.11,2.24,1.55,2.6,2.38V408A.14.14,0,0,1,227.67,408.11Zm-2.76-1.81a.93.93,0,0,0,.23.57,3.83,3.83,0,0,0,2.11.93c-.5-.86-1.65-2-2.12-1.91,0,0-.18,0-.19.31v.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.58 392.03 238.29 392.52 234.33 408.54 227.58 408.05 231.58 392.03",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,407.16c-1.85,2.15-2.83,3.25-8.15,4.91-1.18.36-.18,3.16,2.66,2.91,4.7-.41,2.11-.4,6.11-.75,3.43-.3,7.37-.48,10.1-.67a.86.86,0,0,0,.27-.05,1,1,0,0,0,.67-1.26l-1.84-6a.58.58,0,0,0-.62-.41l-7.53.65A2.39,2.39,0,0,0,226,407.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.57 392.04 229.52 400.27 236.25 400.76 238.29 392.52 231.57 392.04",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.58,243.06a71.48,71.48,0,0,0-6.36,12.8c-3.69,10-2.38,15.18-3.61,21.93-2.17,11.87-5.41,21-7.69,30-7.1,28.19-24.72,87.72-24.72,87.72l12.12,2.67s25.1-69.16,31.48-89.33C277.55,290.7,292.31,243,292.31,243Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.58,243.06a71.48,71.48,0,0,0-6.36,12.8c-3.69,10-2.38,15.18-3.61,21.93-2.17,11.87-5.41,21-7.69,30-7.1,28.19-24.72,87.72-24.72,87.72l12.12,2.67s25.1-69.16,31.48-89.33C277.55,290.7,292.31,243,292.31,243Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.77,393.27l-.12,4.31,14.6,1.58s1.3-4.71,1.24-4.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.77,393.27l-.12,4.31,14.6,1.58s1.3-4.71,1.24-4.71Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.49,265c-4.65,15-10.54,33.91-13.68,43.85-.15.48-.32,1-.48,1.51,1.24-16.6,4.5-44.43,12.84-45.45A3,3,0,0,1,285.49,265Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.76,243s-3.54,45.74-3.94,67.37c-.38,20.15-1.51,88.35-1.51,88.35H288s8.2-69.41,10.27-89.88c2-19.38,7.08-65.45,7.08-65.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.76,243s-3.54,45.74-3.94,67.37c-.38,20.15-1.51,88.35-1.51,88.35H288s8.2-69.41,10.27-89.88c2-19.38,7.08-65.45,7.08-65.45Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.42,232.4l-12.31,25.2,3.26-.94a32.25,32.25,0,0,1,16.09-.48h0l3.83-8.73-1.18,9.19,1.68,0a32.23,32.23,0,0,1,14,2.85,33.79,33.79,0,0,0,4.41,1.83c0-.28,4.12-17.88,4.12-17.88S299.86,214.45,271.42,232.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.57,394.62l.4,4.29,14.21,0s.67-4.81.62-4.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.57,394.62l.4,4.29,14.21,0s.67-4.81.62-4.81Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.55,165.41s-4.14-2.16-4.85-3.95l-1-2.51a1,1,0,0,1,.56-1.24,16.81,16.81,0,0,1,7.51-1.29,1.78,1.78,0,0,1,1.43,1.07s1.06,5,.23,5.55Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.11,164.23,323,176.45c.29.39.57.79.83,1.18,6.44,9.37,7.17,17.49,4.45,18.6S316,199,316,199l1.23-9.71,2.4-.4L309.2,167.24l-.9-2.21S311.1,160.26,314.11,164.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.87,185.76a65.93,65.93,0,0,1,19.95,2.37l1.13,9.08s-17.77,6-23.61-.26C294.86,192.16,293.42,185.15,301.87,185.76Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.11,190c0,.55.07.87.09,1.28l0,1.14c0,.74,0,1.49-.05,2.22-.08,1.48-.24,3-.46,4.43a36.74,36.74,0,0,1-2.51,8.66,26.91,26.91,0,0,1-12.49,13.59,10,10,0,0,1-3.09,1.13,8.86,8.86,0,0,1-3.66-.13,12.46,12.46,0,0,1-5.06-2.75,30.12,30.12,0,0,1-5.68-7,71.35,71.35,0,0,1-6.71-15l4.35-1.81c1.24,2.18,2.55,4.44,4,6.57s2.8,4.24,4.33,6.16a25.16,25.16,0,0,0,4.76,4.8,4.22,4.22,0,0,0,1.88.87c.17,0,.18,0,.25-.05s-.1,0,.53-.39a19.35,19.35,0,0,0,8-9.65,30.12,30.12,0,0,0,1.71-6.52v0a8.25,8.25,0,0,1,6.76-7Z",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.15,199.37c-3-2.4-3-7-3-7l9.65-1.86-3.1,7.48Z",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.86 190.53 163.21 192.38 164.29 185.34 171.21 182.65 172.86 190.53",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.68,178a14,14,0,0,0,3.25,1c.28,0,.55.09.83.11,10.06,1.21,20.06-8.82,22.62-22.88,2.6-14.41-3.64-27.65-14-29.51s-20.83,8.32-23.45,22.74C152.63,162.36,157.33,174.26,165.68,178Zm-5.37-27.56c2.16-11.88,8.47-20.87,14.6-21.31a6.1,6.1,0,0,1,1.35,0h0a21.82,21.82,0,0,1,2.68.38c5.43,1.1,10.54,12.36,8.2,25.28C185,167,177.41,176.2,170,176.23a7.58,7.58,0,0,1-1.5-.11l-.1,0-.35,0-.22-.05a6.17,6.17,0,0,1-1.44-.51C160.87,172.83,158.18,162.27,160.31,150.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.51,175.42a.4.4,0,0,1,0-.12l3.9.91c8.05,0,15.5-9.26,17.74-21.35,2.38-12.92-2.62-24.12-8.54-25.28a25.38,25.38,0,0,0-2.91-.41h0a20.53,20.53,0,0,0-2.46-.19c-6.66.37-13.78,9.4-15.69,21.33C155.75,161.39,158.48,173.62,165.51,175.42Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.14,211.74c3.86,3.88,6,.11,6,.11l.31-3.91,1.4-17.61.43-5.44.09-1,.37-4.7.23-2.93.06-.7-3.64-.16a.4.4,0,0,0,0,.12c-.09.3-.34,1.21-.7,2.54-.09.38-.21.79-.32,1.25-.67,2.54-1.56,6.1-2.42,9.95C160.87,198.57,159,209.59,161.14,211.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.31,298.9s.8,28.09,1,35.45c.6,23.75,6.95,72.43,6.95,72.43l8.2-.23s2.42-48.94-1.27-68.62a6.47,6.47,0,0,1,0-2.28l5.71-35.15Z",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.38,297.77s5.33,22,10.8,35.05c6.62,15.76,35,66.87,35,66.87l5.46-5.13s-14.23-43.26-26.71-65.21a11.28,11.28,0,0,1-1.73-4.08c-.88-6.85-.92-26.9-4-33.86Z",
    style: {
      fill: "#fbd3cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,195.58c0,.11,0,.21,0,.33s0,0,0,0c-.09,1-.22,2.31-.36,3.74a.19.19,0,0,1,0,.08c-1,9.77-3,27.11-2.81,35.53a1.45,1.45,0,0,1,0,.36,2.71,2.71,0,0,1-.13.7,3.49,3.49,0,0,1-2.78,2.41,84.11,84.11,0,0,1-9.75,1.05l-.77,0a4.08,4.08,0,0,0,.06-.79,3.67,3.67,0,0,0-.39-1.56c-2.34,0-4.69,0-6.87,0h-.83c-4.53-.08-8.3-.26-9.94-.35a2.71,2.71,0,0,1,0,.29,2.45,2.45,0,0,1-.08-.29,1.54,1.54,0,0,1-.05-.31,104.26,104.26,0,0,0-3.85-20.41c-1-3.92-1.73-7-1.25-10.45.79-5.65,2.85-9.55,2.91-11.44a3.48,3.48,0,0,1,1.92-3,18.64,18.64,0,0,1,2.74-1.17h0a28.77,28.77,0,0,1,5.45-1h0v.05l.41,1.57.07.09h0l2,2.62.59.13,2.54.54,2.75-.51.46-.08,3.82-2.46h0l1.41-1.14.17-.18.09-.07,0,0a95.09,95.09,0,0,1,9.8,2A3.48,3.48,0,0,1,235,195.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.88,189.7c-2.61-2.59-1.94-14.57-1.94-14.57l-7.26,5.25s-.23,7.4-2,8.88c-.4.35-1,.08-1.52.13l.5,1.87,1.45,2.29,1.94,1.3,2.8-.08,2.5-.79,2.82-2.09,2.29-2C222,189.85,221.26,190.07,220.88,189.7Z",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.22,182.44c4.86-.69,7-3.29,8-5.32l-.27-2-7.26,5.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.51,405.87l9.34-.54a.75.75,0,0,1,.77.54l2.12,7.5a1.24,1.24,0,0,1-.85,1.55,1.09,1.09,0,0,1-.26.05c-3.37.14-6.37.12-10.56.37-4.95.29-3.66.81-9.47,1.23-3.5.25-4.37-3.7-2.89-4,6.74-1.25,7.33-3.34,9.81-5.93A3,3,0,0,1,205.51,405.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.64,396.31l5.2-4.08a.75.75,0,0,1,.94,0l5.62,5.22a1.25,1.25,0,0,1,.25,1.75,1.12,1.12,0,0,1-.18.2c-2.6,2.14-3.47,2.54-6.66,5.26-3.77,3.21-2.43,2.85-6.81,6.69-2.64,2.31-5.72-.31-4.71-1.42,4.63-5.07,4.82-8.2,5.24-11.76A3,3,0,0,1,264.64,396.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.25,238c-.36-.62-.73-1.21-1.13-1.79a5,5,0,0,0-.4-.58c-.14-.21-.28-.42-.43-.61L200,233.35s.15,1.45.28,3.79c1.64.09,5.41.27,9.94.35h.83c2.18,0,4.53,0,6.87,0a3.67,3.67,0,0,1,.39,1.56,4.08,4.08,0,0,1-.06.79,3.83,3.83,0,0,1-.79,1.72c-1.92.1-3.87.17-5.75.23l-1,0a88.37,88.37,0,0,1-10.32-.16,83.82,83.82,0,0,1-.75,13.06c-2.45,16.73-3.44,37.93-1.19,52.17V307c0,.17.06.33.1.5a96.94,96.94,0,0,0,19,1.24,43.76,43.76,0,0,0,5.54-.47c5.45-.78,11.09-.33,17.48-3.94C240.69,304.3,246.3,260.2,233.25,238Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.35,239.05a4.08,4.08,0,0,1-.06.79,3.83,3.83,0,0,1-.79,1.72c-1.92.1-3.87.17-5.75.23l-1,0a88.37,88.37,0,0,1-10.32-.16c0-1.58-.07-3-.14-4.22a2.71,2.71,0,0,0,0-.29c1.64.09,5.41.27,9.94.35h.83c2.18,0,4.53,0,6.87,0A3.67,3.67,0,0,1,218.35,239.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.58,240.46s-7.94.66-16.13,1l-.95.05a3.83,3.83,0,0,0,.79-1.72,4.08,4.08,0,0,0,.06-.79,3.67,3.67,0,0,0-.39-1.56l.82,0a77.53,77.53,0,0,0,12.81-1.13c.18,0,.36-.08.53-.12l.47-.11h0a23.26,23.26,0,0,0,1.61,3.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.13,189.2s2.65,9.51,14.41.73C222.54,189.93,210.41,204.53,208.13,189.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.13,189.2s2.65,9.51,14.41.73C222.54,189.93,210.41,204.53,208.13,189.2Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.09,194.85a1.51,1.51,0,1,1,.09,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.77,167.38c-1.39,6.2-1.85,8.84-5.52,11.54-5.53,4.07-12.84,1-13.34-5.48-.43-5.84,1.91-15,8.44-16.49a8.67,8.67,0,0,1,10.42,10.43Z",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.53,167.41c-.09.51-.43.88-.75.83s-.54-.51-.46-1,.42-.88.75-.83S211.58,166.92,211.53,167.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.77,166.5c-.09.52-.42.88-.75.83s-.54-.51-.46-1,.42-.88.75-.82S205.85,166,205.77,166.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.45,165.54l-1.16-.55S204.76,166.05,205.45,165.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.4,167.71a13.67,13.67,0,0,1-2.35,3,2.24,2.24,0,0,0,1.77.63Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,166.63a.31.31,0,0,1-.29-.21,3.58,3.58,0,0,0-2.16-1.89.31.31,0,0,1-.2-.39.3.3,0,0,1,.37-.2h0a4.1,4.1,0,0,1,2.56,2.29.29.29,0,0,1-.2.37h0A.15.15,0,0,1,214,166.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,163.57a.32.32,0,0,1-.27-.16.31.31,0,0,1,.11-.41,3,3,0,0,1,2.79-.21.29.29,0,0,1,.14.39v0a.29.29,0,0,1-.4.13h0a2.4,2.4,0,0,0-2.18.19A.31.31,0,0,1,204.47,163.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.21,166.49l-1.16-.54S210.52,167,211.21,166.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.55,171.24c-3.25,2.22-3.56,6.86-6.65,9.29-.76-2.13.45-5.56,1-8.08a1.18,1.18,0,0,0,0-.83c-.25-.41-.94-.31-1.25.07a2.37,2.37,0,0,0-.33,1.4c-.1-.24-.19-.48-.28-.71-.22,1-.42,1.91-.64,2.86a10.7,10.7,0,0,1-.14-2.23,4.33,4.33,0,0,1,.4-1.57c-8.71-21.79-7.66-20.08,1.74-19,3.9.45,7.17,3.67,8.28,7.45S230,168.23,225.55,171.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.7,172.46a4.58,4.58,0,0,1-2.7,2.2c-1.53.44-2.32-.93-1.91-2.4.39-1.32,1.64-3.13,3.19-3a2.06,2.06,0,0,1,1.42,3.16Z",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.35,173.6a17.45,17.45,0,0,1,.3,2.5l.45.05c2,.21,3-.36,3.5-1.05A2.62,2.62,0,0,0,211,174a2.47,2.47,0,0,0,0-.7,9.7,9.7,0,0,1-4,.41Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,173.66l.1.73c1.89.19,3.25.08,3.9-.44a2.47,2.47,0,0,0,0-.7A9.7,9.7,0,0,1,207,173.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.1,176.15c2,.21,3-.36,3.5-1.05a6.62,6.62,0,0,0-2.27.21A2.41,2.41,0,0,0,207.1,176.15Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.9 174.09 219.22 177.44 219.64 178.31 220.37 177.4 219.9 174.09",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,197.29a43.06,43.06,0,0,1-.86,4.36c-7.76,23.54-18.53,23.12-21.38,18.35-1.83-.68-.83-27.43-2-32.8l4.49-1.41c1,2.28,3.05,28.08,4.91,24.22,1-2,4.16-8.54,4.68-10.73v0a8.24,8.24,0,0,1,7.36-6.35A4,4,0,0,1,235,197.29Z",
    style: {
      fill: "#fbd3cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.1,190.05c-3.75.83-7.3-2.1-7.3-2.1l4.61-8.68,3.88,7.11Z",
    style: {
      fill: "#fbd3cd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.43 179.27 206.82 187.95 202.01 182.68 204.27 175.61 211.43 179.27",
    style: {
      fill: "#fbd3cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.11,152.22a14.07,14.07,0,0,0-10.38,11.34c1.32-.25,1.91.68,3.21,1a11.65,11.65,0,0,1,5.17-5.17q.91,2.41,1.81,4.85c.33.88.79,2.88.79,2.88a29.8,29.8,0,0,1,3.83.39s1.67-6.47.09-10.79c-.67-1.84-1.49-3.79-3.17-4.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.38,
    y: 236.44,
    width: 1.81,
    height: 6.08,
    transform: "translate(-4.89 4.66) rotate(-1.18)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.12,
    y: 236.82,
    width: 1.81,
    height: 6.08,
    transform: "translate(-4.92 4.29) rotate(-1.18)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.34,237.41a4.83,4.83,0,0,0-9,0l-.13.34,1.35,0,.07-.14a3.55,3.55,0,0,1,3.12-2,3.59,3.59,0,0,1,3.3,2,3.45,3.45,0,0,1,.35,1.46,3.82,3.82,0,0,1-.06.74,3.75,3.75,0,0,1-.75,1.6,3.57,3.57,0,0,1-5.38.17l-.07-.09-1.55,0,.27.38a4.83,4.83,0,0,0,8.09-.25,4.53,4.53,0,0,0,.65-1.8,3.56,3.56,0,0,0,.06-.82A4.57,4.57,0,0,0,217.34,237.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-2--inject-91"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.42,264a41.07,41.07,0,0,1-34.69,27.1,35.94,35.94,0,0,1-12.39-1.11,32.5,32.5,0,0,1-17.19-11.3l29.69-24.09-34.57-9.4c6.24-17.65,24-28.85,41.44-27h0a36.05,36.05,0,0,1,5.6,1C371.44,224.34,381.32,244.4,374.42,264Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.42,264a41.07,41.07,0,0,1-34.69,27.1,35.94,35.94,0,0,1-12.39-1.11,32.5,32.5,0,0,1-17.19-11.3l29.69-24.09-34.57-9.4c6.24-17.65,24-28.85,41.44-27h0a36.05,36.05,0,0,1,5.6,1C371.44,224.34,381.32,244.4,374.42,264Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.12,264c-6.22,17.62-24,28.81-41.39,27A41.07,41.07,0,0,0,374.42,264c6.9-19.55-3-39.61-22.07-44.8a36.05,36.05,0,0,0-5.6-1,35.43,35.43,0,0,1,12.3,1.11C378.14,224.41,388,244.45,381.12,264Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.12,264c-6.22,17.62-24,28.81-41.39,27A41.07,41.07,0,0,0,374.42,264c6.9-19.55-3-39.61-22.07-44.8a36.05,36.05,0,0,0-5.6-1,35.43,35.43,0,0,1,12.3,1.11C378.14,224.41,388,244.45,381.12,264Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "331.75 255.99 302.05 280.08 295.35 280.02 325.04 255.93 290.47 246.53 297.17 246.58 331.75 255.99",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.75 255.99 302.05 280.08 295.35 280.02 325.04 255.93 290.47 246.53 297.17 246.58 331.75 255.99",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,255.93,295.35,280c-7-8.85-9.19-21.27-4.88-33.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325,255.93,295.35,280c-7-8.85-9.19-21.27-4.88-33.49Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-1--inject-91"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.5,282.93H93.09a8.26,8.26,0,0,1-8.36-9.15L88,236.21a10.18,10.18,0,0,1,10-9.15h99.42a8.25,8.25,0,0,1,8.35,9.15l-3.29,37.57A10.19,10.19,0,0,1,192.5,282.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.5,282.93H93.09a8.26,8.26,0,0,1-8.36-9.15L88,236.21a10.18,10.18,0,0,1,10-9.15h99.42a8.25,8.25,0,0,1,8.35,9.15l-3.29,37.57A10.19,10.19,0,0,1,192.5,282.93Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.09,276.1h-8.28a.79.79,0,0,1-.8-.89l3.47-39.66a1,1,0,0,1,1-.89h8.27a.8.8,0,0,1,.81.89l-3.47,39.66A1,1,0,0,1,115.09,276.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.88,276.1h-8.27a.8.8,0,0,1-.81-.89l3.47-39.66a1,1,0,0,1,1-.89h8.28a.8.8,0,0,1,.8.89l-3.47,39.66A1,1,0,0,1,182.88,276.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.16,276.1h-8.27a.8.8,0,0,1-.81-.89l2.28-26a1,1,0,0,1,1-.89h8.27a.8.8,0,0,1,.81.89l-2.28,26A1,1,0,0,1,150.16,276.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.77,276.1H124.5a.8.8,0,0,1-.81-.89l1.7-19.33a1,1,0,0,1,1-.89h8.27a.8.8,0,0,1,.81.89l-1.69,19.33A1,1,0,0,1,132.77,276.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.52,276.1h-8.27a.8.8,0,0,1-.81-.89l.27-3.11a1,1,0,0,1,1-.89H167a.8.8,0,0,1,.81.89l-.28,3.11A1,1,0,0,1,166.52,276.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.76,232a1,1,0,0,0-1.26.46l-15.33,30.75a.89.89,0,0,1-1.59.12l-12-23.68a.84.84,0,0,0-1.23-.28l-16.28,10.31a.88.88,0,0,1-.92,0L111,236.33a.94.94,0,0,0-1.27.41l-.06.1A.85.85,0,0,0,110,238l24,13.91a.9.9,0,0,0,.92,0l15.63-9.9a.86.86,0,0,1,1.23.28l12.71,25a.9.9,0,0,0,1.59-.11l17-34.06A.83.83,0,0,0,182.76,232Z",
    style: {
      opacity: 0.30000000000000004
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindProducts);
export default __webpack_public_path__ + "static/media/find-products.789ebcb223bda1b90a24c030a7950bbf.svg";
export { ForwardRef as ReactComponent };